/**
 * Backfills the lastLogin field for a user who has never logged in.
 * Calls getCognitoUser to determine the user's status and updates DynamoDB accordingly.
 * 
 * @param {Object} user - The user object from GraphQL (must have id, email, lastLogin, group)
 * @param {Function} getCognitoUser - Function to call Cognito AdminGetUser
 * @param {Function} api - The GraphQL API wrapper (this.api)
 * @param {Object} updateUserMutation - The updateUser GraphQL mutation
 * @returns {String} The resolved lastLogin value
 */
export async function backfillLastLogin(user, getCognitoUser, api, updateUserMutation) {
  if (user.lastLogin) return user.lastLogin

  let newUserLastLogin = 'NOT_YET_LOGGED'
  try {
    const cognitoUser = await getCognitoUser(user.email)
    if (cognitoUser.UserStatus === 'FORCE_CHANGE_PASSWORD') {
      newUserLastLogin = 'NOT_YET_LOGGED'
    } else {
      newUserLastLogin = new Date('1970/01/01').toISOString()
    }
    await api(updateUserMutation, {input: { id: user.id, lastLogin: newUserLastLogin, ...(user.group?.length && { group: user.group }) }})
  } catch (e) {
    console.error('Failed to backfill lastLogin for user:', user.email, e)
    newUserLastLogin = 'NOT_YET_LOGGED'
  }

  return newUserLastLogin
}
